import { apiClient } from "../config";

async function deleteCommunity(id: any) {
  const url = `/admin/communities/${id}`;
  const res = await apiClient.delete(url);
  return res.data;
}

export default deleteCommunity;
